import WebApp from '@twa-dev/sdk'

// Telegram Cloud Storage Utility Functions
export const uploadTgCloudStorage = async (key: string, value: string): Promise<boolean> => {
    return new Promise((resolve, reject) => {
        WebApp.CloudStorage.setItem(key, value, (error, isSuccess) => {
            if (error) {
                reject(error); // 에러 발생 시 Promise reject
            } else {
                resolve(isSuccess ?? false); // undefined일 경우 기본값 false 설정
            }
        });
    });
};

export const downloadTgCloudStorage = async (key: string): Promise<string | null> => {
    return new Promise((resolve, reject) => {
        WebApp.CloudStorage.getItem(key, (error, value) => {
            if (error) {
                reject(error); // 에러 발생 시 Promise reject
            } else {
                resolve(value ?? null); // undefined일 경우 기본값 null 설정
            }
        });
    });
};

export const clearTgCloudStorage = async (key: string): Promise<boolean> => {
    return new Promise((resolve, reject) => {
        WebApp.CloudStorage.removeItem(key, (error, isSuccess) => {
            if (error) {
                reject(error); // 에러 발생 시 Promise reject
            } else {
                resolve(isSuccess ?? false); // undefined일 경우 기본값 false로 설정
            }
        });
    });
};
